import { xposParamsMap } from '@didi/webx-js-core';
import { getNineChapterCommonParams } from '../statistic';
import { sdkReady } from '../platform/loader';
import { isXpub } from '../utils/isXpub';
import { version } from '../version';
let callbackQueue = []; // 回调队列
let omegaInitializing = false;
let omegaInitialized = false;
let omegaSetAttrs = false;
let versionReported = false;
const omegaSDKConfig = {
    sdkUrl: 'https://tracker.didistatic.com/static/tracker/__version__/xspm.min.js',
    // sdkUrl: 'https://tracker.didistatic.com/static/tracker/beta/xspm.min.js',
    version: 'latest2x'
};
const cleanEmptyKey = (obj) => {
    const propNames = Object.getOwnPropertyNames(obj);
    for (let i = 0; i < propNames.length; i++) {
        let propName = propNames[i];
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
};
const _getSDKUrl = () => {
    const { sdkUrl, version } = omegaSDKConfig;
    return sdkUrl.replace('__version__', version);
};
const _proxyOmegaInXpub = () => {
    return new Proxy({}, {
        get: function (_, prop) {
            return (...args) => {
                console.log(`skip Omega.${String(prop)} in xpub: ${JSON.stringify(args)}`);
            };
        }
    });
};
const _getOmega = (callback) => {
    if (isXpub()) {
        const sdk = _proxyOmegaInXpub();
        if (callback)
            callback(sdk);
        return sdk;
    }
    if (window.Omega && window.Omega.trackEvent) {
        if (!omegaSetAttrs) {
            omegaSetAttrs = true;
            setOmegaAttrs();
        }
        reportVersion(window.Omega);
        if (callback)
            callback(window.Omega);
        return window.Omega;
    }
    else {
        if (callback)
            callbackQueue.push(callback);
        initOmega();
    }
};
const initOmega = () => {
    if (omegaInitialized || omegaInitializing)
        return;
    omegaInitializing = true;
    sdkReady('Omega', _getSDKUrl(), (sdk) => {
        window.Omega = sdk;
        if (!omegaSetAttrs) {
            omegaSetAttrs = true;
            setOmegaAttrs();
        }
        omegaInitialized = true;
        omegaInitializing = false;
        reportVersion(sdk);
        callbackQueue.forEach(callback => callback(sdk));
    });
};
const reportVersion = (omega) => {
    if (versionReported === false) {
        versionReported = true;
        omega.trackEvent('pub_webx_jssdk_init_bt', 'webx-jssdk初始化', {
            version,
            type: 'web'
        });
    }
};
export const setOmegaConfig = (config) => {
    _getOmega((omega) => {
        omega.setConfig(config);
    });
};
export const setOmegaAttrs = (attrs = {}) => {
    _getOmega((omega) => {
        if (omega.canUseXspm) {
            if (Object.prototype.toString.call(attrs) === '[Object Object]' &&
                Object.keys(attrs).length === 0) {
                const collection = getNineChapterCommonParams();
                collection['xspm'] = undefined;
                cleanEmptyKey(collection);
                omega.setAttrs(collection);
            }
            else {
                omega.setAttrs(attrs);
            }
            omegaSetAttrs = true;
        }
        else {
            console.warn('当前版本Omega不支持设置公共参数方法Omega.setAttrs, setOmegaAttrs未生效', omega);
        }
    });
};
const injectNineChapterParams = (attrs = {}) => {
    const collection = getNineChapterCommonParams();
    collection['xspm'] = attrs['xspm'] || undefined;
    const result = Object.assign({}, collection, attrs);
    cleanEmptyKey(result);
    return result;
};
const refactorXspmInfo = (xspmInfo = { a: '', b: '', c: '', d: '' }) => {
    const collection = getNineChapterCommonParams();
    if (!xspmInfo['a'])
        xspmInfo['a'] = collection['prod_key'];
    return xspmInfo;
};
export const trackEvent = (id, label, attrs, cb) => {
    /* 新增九章参数注入流程 */
    const finalAttrs = injectNineChapterParams(attrs);
    _getOmega((omega) => {
        omega.trackEvent(id, label, finalAttrs, cb);
    });
};
export const trackError = (type, code, label, level, attrs) => {
    _getOmega((omega) => {
        omega.trackError(type, code, label, Object.assign({ pub_omg_error_level: level || 0 }, attrs || {}));
    });
};
export const sendXspmClick = (attrs = {}, xspmInfo = { a: '', b: '', c: '', d: '' }) => {
    _getOmega((omega) => {
        /* 新增九章参数注入流程 */
        const finalAttrs = injectNineChapterParams(attrs);
        const finalXspmInfo = refactorXspmInfo(xspmInfo);
        omega.sendXspmClick(finalAttrs, finalXspmInfo);
    });
};
export const sendXspmScan = (attrs = {}, xspmInfo = { a: '', b: '', c: '', d: '' }) => {
    _getOmega((omega) => {
        /* 新增九章参数注入流程 */
        const finalAttrs = injectNineChapterParams(attrs);
        const finalXspmInfo = refactorXspmInfo(xspmInfo);
        omega.sendXspmScan(finalAttrs, finalXspmInfo);
    });
};
/**
 * trackPageShow: 页面展现埋点
 * @param
 * @example
 * ```js
 *  trackPageShow()
 * ```
 */
export const trackPageShow = (attrs = {}) => {
    /* 新增九章参数注入流程 */
    const finalAttrs = injectNineChapterParams(attrs);
    _getOmega((omega) => {
        omega.trackEvent('pub_webx_page_sw', 'webx页面展现', finalAttrs);
    });
};
/**
 * trackXposEvent: 交互事件埋点
 * @param
 * @example
 * ```js
 *  trackXposEvent()
 * ```
 */
export const trackResourceEvent = (resourceInfo, data = {}, attrs = {}) => {
    let _resourceInfo = resourceInfo;
    /* 默认注入prod_key */
    if (getNineChapterCommonParams().prod_key)
        _resourceInfo['pk'] = getNineChapterCommonParams().prod_key;
    /* End 默认注入prod_key */
    /* xpos参数映射 */
    const formattedResourceInfo = Object.entries(_resourceInfo).reduce((res, [key, value]) => {
        if (xposParamsMap[key]) { // 需要映射 进行key转换
            res[xposParamsMap[key]] = value;
        }
        else {
            res[key] = value;
        }
        return res;
    }, {});
    /* End xpos参数映射 */
    const xposItem = { xpos: formattedResourceInfo };
    if (formattedResourceInfo.idx)
        xposItem['idxs'] = [{ idx: formattedResourceInfo.idx, data }];
    else
        xposItem['data'] = data;
    const xpos_list = [xposItem];
    /* 新增九章参数注入流程 */
    const finalAttrs = injectNineChapterParams(Object.assign({}, { xpos_list }, attrs));
    _getOmega((omega) => {
        omega.trackEvent('pub_webx_position_ck', 'webx运营位点击', finalAttrs);
    });
};
/**
 * trackXposExposure: 曝光事件埋点
 * @param
 * @example
 * ```js
 *  trackXposExposure()
 * ```
 */
export const trackResourceExposure = (resourceInfo, data = {}, attrs = {}) => {
    let _resourceInfo = resourceInfo;
    /* 默认注入prod_key */
    if (getNineChapterCommonParams().prod_key)
        _resourceInfo['pk'] = getNineChapterCommonParams().prod_key;
    /* End 默认注入prod_key */
    /* xpos参数映射 */
    const formattedResourceInfo = Object.entries(_resourceInfo).reduce((res, [key, value]) => {
        if (xposParamsMap[key]) { // 需要映射 进行key转换
            res[xposParamsMap[key]] = value;
        }
        else {
            res[key] = value;
        }
        return res;
    }, {});
    /* End xpos参数映射 */
    const xposItem = { xpos: formattedResourceInfo };
    if (formattedResourceInfo.idx)
        xposItem['idxs'] = [{ idx: formattedResourceInfo.idx, data }];
    else
        xposItem['data'] = data;
    const xpos_list = [xposItem];
    /* 新增九章参数注入流程 */
    const finalAttrs = injectNineChapterParams(Object.assign({}, { xpos_list }, attrs));
    _getOmega((omega) => {
        omega.trackEvent('pub_webx_position_sw', 'webx运营位曝光', finalAttrs);
    });
};
export const getOmega = _getOmega;
